import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'
import { CartBadge } from '@/components/ui/CartBadge'
import { useAuth } from '@/auth/useAuth'
import { useBranding, useStorefrontContent } from '@/branding/BrandingProvider'

export function LandingNavbar() {
  const { isAuthenticated, logout } = useAuth()
  const { siteName, logoUrl, skin } = useBranding()
  const { nav } = useStorefrontContent()
  const isLuxury = skin === 'luxury'

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          {logoUrl ? (
            <img src={logoUrl} alt={siteName} className="h-8 w-auto" />
          ) : isLuxury ? (
            <Icon icon="solar:crown-line-bold" className="text-3xl" style={{ color: 'var(--lux-gold)' }} />
          ) : (
            <div className="w-8 h-8 rounded-lg bg-navy flex items-center justify-center">
              <Icon icon="solar:health-linear" className="text-white text-lg" />
            </div>
          )}
          <span className="text-xl font-medium text-navy tracking-tight">{siteName}</span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600">
          {nav.map((n) => (
            <a key={n.href} href={n.href} className="hover:text-navy transition-colors">{n.label}</a>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <CartBadge />
          {isAuthenticated ? (
            <button
              onClick={() => logout()}
              className="bg-navy text-white text-sm font-medium px-5 py-2.5 rounded-full hover:bg-slate-800 transition-colors shadow-sm"
            >
              Logout
            </button>
          ) : (
            <a
              href="/portal/"
              className="bg-navy text-white text-sm font-medium px-5 py-2.5 rounded-full hover:bg-slate-800 transition-colors shadow-sm"
            >
              Login / Portal
            </a>
          )}
        </div>
      </div>
    </nav>
  )
}
